import { ItemStyleOption } from 'echarts/types/src/util/types';
import { Option } from '../../core/option';

export function getSeriesRelatedOption(seriesIndex: number, option: Option): null | Option {
  const result = { ...option };
  const series = (Array.isArray(option.series) ? option.series : [option.series])[seriesIndex];
  if (!series) {
    return null;
  }
  result.series = series;

  const { xAxisIndex = 0, yAxisIndex = 0 } = series;
  const xAxis = Array.isArray(option.xAxis) ? option.xAxis[xAxisIndex] : option.xAxis;
  if (xAxis) {
    result.xAxis = xAxis;
  }
  const yAxis = Array.isArray(option.yAxis) ? option.yAxis[yAxisIndex] : option.yAxis;
  if (yAxis) {
    result.yAxis = yAxis;
  }
  const { gridIndex = 0 } = xAxis;
  const grid = Array.isArray(option.grid) ? option.grid[gridIndex] : option.grid;
  if (grid) {
    result.grid = grid;
  }
  return result;
}
